import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from 'react-router-dom';

const JIRA_PORTAL_URL = 'https://marminai.atlassian.net/servicedesk/customer/portal/34';

const SidebarFooter = () => (
  <Box
    sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 10,
      backgroundColor: (theme) => theme.palette.background.default,
      borderTop: '2px solid',
      borderColor: 'divider',
    }}
  >
    <List>
      <ListItemButton component="a" href={JIRA_PORTAL_URL} target="_blank" sx={{ pl: 2.5 }}>
        <ListItemIcon>
          <HelpOutlineIcon />
        </ListItemIcon>
        <ListItemText primary="Help & Support" />
      </ListItemButton>

      <ListItemButton component={Link} to="/settings" sx={{ pl: 2.5 }}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Settings" />
      </ListItemButton>
    </List>
  </Box>
);

export default SidebarFooter;
